export enum NewRegistrationType {
  Default = "Default",
  ActivationCode = "ActivationCode"
}
